<template>
  <div class="container">
    <!-- 操作按钮区域 -->
    <a-row :gutter="[20, 20]">
      <a-col :span="24">
        <div class="table-operator">
          <!-- <a-button @click="handleAdd" type="primary" icon="plus" ghost style="margin-right: 10px">
            新增
          </a-button> -->
          <!-- <a-button
            @click="batchDel"
            :disabled="selectedRowKeys.length <= 0"
            ghost
            type="primary"
            icon="delete"
          >
            批量删除
          </a-button> -->
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <TableList
          rowKey="id"
          bordered
          :loading="loading"
          :columns="columns"
          :tableData="dataSource"
          :scroll="false"
          :pagination="ipagination"
          @change="handleTableChange"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        >
          <div slot="action" slot-scope="{ record }" style="cursor: pointer">
            <!-- <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" /> -->
            <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
            <a-divider type="vertical" />
            <a-popconfirm title="确定推送文章吗?" @confirm="() => notification(record)">
              <a>推送</a>
            </a-popconfirm>
          </div>
        </TableList>
      </a-col>
    </a-row>
    <!-- <RichTextModal ref="modalForm" @ok="modalFormOk" @updateTable="updateTable" /> -->
    <ViewPhoto v-if="showViewPhoto" ref="viewPhotoRef" @close="showViewPhoto = false" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
// import RichTextModal from './components/RichTextModal'
import { getAction } from '@api/manage'
import moment from 'moment'
import ViewPhoto from './modules/ViewPhoto.vue'

export default {
  name: 'Feedback',
  components: { TableList, ViewPhoto },
  mixins: [JeecgListMixin],
  data() {
    return {
      columns: [
        {
          title: '反馈内容',
          dataIndex: 'feedbackText',
          align: 'center',
          //   限制最大宽度
          customCell: () => {
            return {
              style: {
                maxWidth: '800px',
              },
            }
          },
        },
        {
          title: '图片信息',
          dataIndex: 'feedbackImageUrls',
          align: 'center',
          customRender: (_, record) => {
            const urlList = record.feedbackImageUrls && record.feedbackImageUrls.split(',')
            return (
              <div>
                {urlList.length > 0 ? (
                  urlList.map((url, index) => (
                    <img
                      onClick={() => this.imgClick(url, index, urlList)}
                      key={index}
                      src={url}
                      style={{ width: '50px', height: '50px', marginRight: '5px' }}
                    />
                  ))
                ) : (
                  <div>暂无图片</div>
                )}
              </div>
            )
          },
        },
        {
          title: '联系方式',
          dataIndex: 'phone',
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'phone',
          align: 'center',
          customRender: (_, record) => {
            return moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      tableData: [],
      url: {
        list: '/aigoes/fedBack/list',
        deleteBatch: '/dataReport/deleteBatch',
        delete: '/dataReport/delete',
      },
      showViewPhoto: true,
    }
  },
  methods: {
    async imgClick(url, index, urlList) {
      console.log('图片路径--', url, index, urlList)
      this.showViewPhoto = true
      await this.$nextTick()
      this.$refs.viewPhotoRef.show(url, index, urlList)
    },
    updateTable() {
      this.loadData()
    },
    notification(record) {
      getAction('/ddUser/parentDingMessage', {
        userId: '02503962506836284993',
        urlDing: `pagesA/pages/DataReport/index?id=${record.id}`,
        text: '测试',
      }).then((res) => {
        if (res.success) {
          this.$message.success('文章推送成功')
          return true
        }
        this.$message.error('文章推送失败')
      })
      //   getAction('/ddUser/getParentIds', {
      //     studentId: this.studentInfo.studentId,
      //     urlDing: 'pagesA/pages/Home/h-rector/detail?role=4&corpId=',
      //     text: '# 爱心小叮当  \\n  ' + this.content,
      //   }).then((res) => {
      //     if (res.success) {
      //       this.$message.success('消息推送成功')
      //     }
      //   })
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 20px;
  min-height: 70vh;
}
</style>
